export const ACTION_TYPES = {
  VIEW_CONCEPT: "VIEW CONCEPT",
  VIEW_SAVED_ASSETS: "VIEW SAVED ASSETS",
  VIEW_IMAGE_LIST: "VIEW IMAGE LIST",
  VIEW_COPY_LIST: "VIEW COPY LIST",
  USE_TO_GENERATE_ASSETS: "USE TO GENERATE ASSETS",
  RETURN_TO_OUTPUT_SCREEN: "RETURN TO OUTPUT SCREEN",
  VIEW_VIDEO: "VIEW VIDEO",
  VIEW_SAVED_CONTENT: "VIEW SAVED CONTENT",
  RETURN_TO_CONVERSATION: "RETURN TO CONVERSATION",
  RETURN_TO_CONVERSATION_STORYBOARD: "RETURN TO CONVERSATION STORYBOARD",
} as const;

export const ACTION_TYPES_LABEL: Record<string, string> = {
  "RETURN TO CONVERSATION STORYBOARD": "RETURN TO CONVERSATION",
};

export const TOAST_ARCHIVE_MESSAGE = "has moved to the Archive folder";
export const TOAST_REMOVE_ARCHIVE_MESSAGE = "has been moved out of the Archive folder";
export const TOAST_FAVORITE_MESSAGE = "has added to Favorites";
export const TOAST_REMOVED_FAVORITE_MESSAGE = "has been removed from Favorites";

export const SAVED_ASSETS = "Saved Assets";
export const SAVED_PROJECTS = "Saved Projects";
export const ARCHIVE = "Archive";
export const IMAGE = "Image";

export const SAVED_WORK_TYPES = {
  PDP: "Lifestyle Image",
  PDP_COPY: "Copy for PDP",
  ASSET: "Asset",
  CAMPAIGN: "Concept",
  BACKGROUND: "Background",
  VIDEO: "Video",
  CONTENT: "Content",
  STORYBOARD: "Storyboard",
} as const;

export const SELECT_PROJECT = "Select";
export const UNARCHIVE = "Unarchive";
export const SAVED_WORK_SUBTEXT =
  "Projects and assets you've generated are saved here. If you've generated any new versions, they will replace any previous versions in the links below.";

export const SAVED_ASSET_TYPE = {
  VISUAL_TEXT: "visual_text",
  VISUAL: "visual",
  TEXT: "text",
};

export const CONTENT_MAP: Record<string, string> = {
  claim: "Certifications",
};

export const SEPARATORS = {
  dimensionSeparator: "_",
  versionSeparator: "-",
};
